import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTimes, faSearch, faFile, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { ArchivesService, Archive } from '../../services/archives.service';
import { isDeployableFile } from '../../services/knowledge-base.service';
import { AlertService } from '../alert-service/alert-service';

export interface SelectedArchive {
  id: string;
  name: string;
}

@Component({
  selector: 'app-modal-select-archive-kb',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './modal-select-archive-kb.component.html',
  styleUrls: ['./modal-select-archive-kb.component.scss'],
})
export class ModalSelectArchiveKbComponent implements OnChanges {
  @Input() show = false;
  @Output() close = new EventEmitter<void>();
  @Output() selected = new EventEmitter<SelectedArchive>();

  faTimes = faTimes;
  faSearch = faSearch;
  faFile = faFile;
  faInfoCircle = faInfoCircle;

  loading = false;
  searchTerm = '';
  archives: Archive[] = [];

  constructor(
    private archivesService: ArchivesService,
    private alert: AlertService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show']?.currentValue) {
      this.searchTerm = '';
      this.load();
    }
  }

  load(): void {
    this.loading = true;
    this.archivesService.list(undefined, this.searchTerm?.trim() || undefined, 1, 50).subscribe({
      next: (response) => {
        this.archives = (response.archives || []).filter(a => isDeployableFile(a.name));
        this.loading = false;
      },
      error: (err) => {
        this.alert.showError(err);
        this.loading = false;
        this.archives = [];
      },
    });
  }

  onSearchChange(): void {
    this.load();
  }

  onSelect(archive: Archive): void {
    this.selected.emit({ id: String(archive.id), name: archive.name });
  }

  onClose(): void {
    this.close.emit();
  }
}
